
import { defineComponent } from 'vue'

import CouponFeatured from '../../components/coupon/CouponFeatured.vue'
import CouponPageNormal from '../../components/coupon/CouponPageNormal.vue'
import PlatinumMemberBox from '../../components/coupon/PlatinumMemberBox.vue'

import { CouponShowCaseModel } from '@/types/Coupon'
import { CustomerMVPModel } from '@/types/Customer'
import { GetCouponShowCase, GetCustomerMVPInfo } from '@/api/CouponClient'

export default defineComponent({
  name: 'App',
  components: { CouponFeatured, CouponPageNormal, PlatinumMemberBox },
  data () {
    return {
      couponFeaturedList: [] as Array<CouponShowCaseModel>,
      couponNormalList: [] as Array<CouponShowCaseModel>,
      mvpInfo: null as null | CustomerMVPModel
    }
  },
  created () {
    GetCouponShowCase((window as any).couponPageFeatured).then(infos => {
      this.couponFeaturedList = infos
    })
    GetCouponShowCase((window as any).couponNormalType).then(infos => {
      this.couponNormalList = infos
    })
    GetCustomerMVPInfo().then(info => {
      this.mvpInfo = info
    })
  }
})
